import React, { useRef } from 'react';

import { Footer, Header, Meta } from '$partials/global';
import { useAjaxListing } from '$hooks/ajax-listing';
import { AjaxListingContext, InfinitePagination } from '$partials/base';
import { ArtistListingItem, WorkListingItem } from '$partials/items';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').SearchPage}
 */
const SearchPage = (props) => {
    const bodyRef = useRef();

    const listing = useAjaxListing({
        infinite: true,
        items: props.data?.items?.edges,
        path: '/api/v1/search',
        page: props.data?.items?.page || 1,
        totalItems: props.data?.items?.total || 0,
        totalPages: props.data?.items?.totalPages,
        query: {
            term: props.data.term
        }
    });

    const splitIntoRows = (arr, numCols) => {
        return arr.reduce((cols, item, i) => {
            cols[i % numCols].push(item);
            return cols;
        }, Array.from({ length: numCols }, () => []));
    };

    return (
        <>
            <Meta domain={props.domain} />
            <Header
                {...props?.data?.header}
                bodyRef={bodyRef}
                domain={props.domain}/>
            <div className='min-h-[calc(100dvh-36px)] flex flex-col'>
                <main
                    id='main-content'
                    ref={bodyRef}>
                    <div className='px-layout-outer pt-[100px] pb-32 sticky top-0 bg-white z-10'>
                        <div className='-mx-layout-col flex'>
                            <div className='px-layout-col flex flex-col w-full sm:w-3/7'>
                                <h1>
                                    {'Results for: '}{props.data.term}
                                </h1>
                                <p className='whitespace-pre-wrap sm:pr-[170px]'>
                                    {listing.totalItems}{' items'}
                                </p>
                            </div>
                        </div>
                    </div>
                    <AjaxListingContext.Provider value={listing}>
                        <div className='bg-[white] z-10 relative flex flex-wrap'>
                            <div className='sm:hidden w-full'>
                                {listing.items.map((item, idx) => {
                                    const itm = item.node;
                                    return (
                                        <div key={itm.id}>
                                            {itm.__typename === 'WorkDetailPage' ? <WorkListingItem {...itm}/> : <ArtistListingItem {...itm}/>}
                                        </div>
                                    );
                                })}
                            </div>
                            <div className='hidden sm:flex w-full'>
                                <div className='w-2/7'>
                                    {splitIntoRows(listing.items, 3)[0].map((item, idx) => {
                                        const itm = item.node;
                                        return (
                                            <div key={itm.id}>
                                                {itm.__typename === 'WorkDetailPage' ? (
                                                    <WorkListingItem
                                                        displayTitle={true}
                                                        {...itm}/>
                                                ) : <ArtistListingItem {...itm}/> }
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className='w-3/7'>
                                    {splitIntoRows(listing.items, 3)[1].map((item, idx) => {
                                        const itm = item.node;
                                        return (
                                            <div key={itm.id}>
                                                {itm.__typename === 'WorkDetailPage' ? (
                                                    <WorkListingItem
                                                        displayTitle={true}
                                                        {...itm}/>
                                                ) : <ArtistListingItem {...itm}/>}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className='w-2/7'>
                                    {splitIntoRows(listing.items, 3)[2].map((item, idx) => {
                                        const itm = item.node;
                                        return (
                                            <div key={itm.id}>
                                                {itm.__typename === 'WorkDetailPage' ? (
                                                    <WorkListingItem
                                                        displayTitle={true}
                                                        {...itm}/>
                                                ) : <ArtistListingItem {...itm}/>}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* No result */}
                            {listing.items?.length === 0 && (
                                <div className='px-layout-outer type-style-s'>
                                    {'No results'}
                                </div>
                            )}
                        </div>
                        <InfinitePagination />
                    </AjaxListingContext.Provider>
                </main>

                <Footer {...props?.data?.footer} />
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default SearchPage;
